export default "__VITE_PUBLIC_ASSET__9896a7b7__"